// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AddGroupMemberData,
  AddGroupMemberErrors,
  AddGroupMemberResponses,
  AddProjectMemberData,
  AddProjectMemberErrors,
  AddProjectMemberResponses,
  AdminActivityActionsData,
  AdminActivityActionsResponses,
  AdminActivityAnalyticsData,
  AdminActivityAnalyticsErrors,
  AdminActivityAnalyticsResponses,
  AdminApprovePromotionRequestData,
  AdminApprovePromotionRequestErrors,
  AdminApprovePromotionRequestResponses,
  AdminApproveServiceBudgetRequestData,
  AdminApproveServiceBudgetRequestErrors,
  AdminApproveServiceBudgetRequestResponses,
  AdminDeleteProjectData,
  AdminDeleteProjectErrors,
  AdminDeleteProjectResponses,
  AdminDeleteUserData,
  AdminDeleteUserErrors,
  AdminDeleteUserResponses,
  AdminGetAiServicesData,
  AdminGetAiServicesResponses,
  AdminGetDeployIdentityScopeReadinessData,
  AdminGetDeployIdentityScopeReadinessResponses,
  AdminGetUserData,
  AdminGetUserErrors,
  AdminGetUserResponses,
  AdminInviteUserData,
  AdminInviteUserErrors,
  AdminInviteUserResponses,
  AdminListActivityData,
  AdminListActivityErrors,
  AdminListActivityResponses,
  AdminListPromotionRequestsData,
  AdminListPromotionRequestsResponses,
  AdminListServiceBudgetRequestsData,
  AdminListServiceBudgetRequestsResponses,
  AdminListUsersData,
  AdminListUsersErrors,
  AdminListUsersResponses,
  AdminRefreshProjectsData,
  AdminRefreshProjectsErrors,
  AdminRefreshProjectsResponses,
  AdminReissueServiceKeysData,
  AdminReissueServiceKeysErrors,
  AdminReissueServiceKeysResponses,
  AdminRejectPromotionRequestData,
  AdminRejectPromotionRequestErrors,
  AdminRejectPromotionRequestResponses,
  AdminRejectServiceBudgetRequestData,
  AdminRejectServiceBudgetRequestErrors,
  AdminRejectServiceBudgetRequestResponses,
  AdminRevokeServiceKeyData,
  AdminRevokeServiceKeyErrors,
  AdminRevokeServiceKeyResponses,
  AdminRotateServiceKeyData,
  AdminRotateServiceKeyErrors,
  AdminRotateServiceKeyResponses,
  AdminRunDeployIdentityScopeMigrationData,
  AdminRunDeployIdentityScopeMigrationErrors,
  AdminRunDeployIdentityScopeMigrationResponses,
  AdminSetLlmModeData,
  AdminSetLlmModeErrors,
  AdminSetLlmModeResponses,
  AdminSetProjectSuspensionData,
  AdminSetProjectSuspensionErrors,
  AdminSetProjectSuspensionResponses,
  AdminSetServiceBudgetData,
  AdminSetServiceBudgetErrors,
  AdminSetServiceBudgetResponses,
  AdminSetServiceKillSwitchData,
  AdminSetServiceKillSwitchErrors,
  AdminSetServiceKillSwitchResponses,
  AdminSetServiceSuspensionData,
  AdminSetServiceSuspensionErrors,
  AdminSetServiceSuspensionResponses,
  AdminSetServiceTierData,
  AdminSetServiceTierErrors,
  AdminSetServiceTierResponses,
  AdminUpdateUserData,
  AdminUpdateUserErrors,
  AdminUpdateUserResponses,
  ApproveAppRegistrationData,
  ApproveAppRegistrationErrors,
  ApproveAppRegistrationResponses,
  CancelProjectScaffoldData,
  CancelProjectScaffoldErrors,
  CancelProjectScaffoldResponses,
  CheckSignInApprovalData,
  CheckSignInApprovalErrors,
  CheckSignInApprovalResponses,
  CreateAppRegistrationAmendmentData,
  CreateAppRegistrationAmendmentErrors,
  CreateAppRegistrationAmendmentResponses,
  CreateAppRegistrationRequestData,
  CreateAppRegistrationRequestErrors,
  CreateAppRegistrationRequestResponses,
  CreateGroupData,
  CreateGroupErrors,
  CreateGroupResponses,
  CreateProjectData,
  CreateProjectErrors,
  CreateProjectResponses,
  DeleteGroupData,
  DeleteGroupErrors,
  DeleteGroupResponses,
  DeleteProjectAzureData,
  DeleteProjectAzureErrors,
  DeleteProjectAzureResponses,
  DeleteProjectData,
  DeleteProjectErrors,
  DeleteProjectGithubData,
  DeleteProjectGithubErrors,
  DeleteProjectGithubResponses,
  DeleteProjectResponses,
  DownloadProjectEnvData,
  DownloadProjectEnvErrors,
  DownloadProjectEnvResponses,
  DownloadProjectInstructionsData,
  DownloadProjectInstructionsErrors,
  DownloadProjectInstructionsResponses,
  GenerateProjectData,
  GenerateProjectErrors,
  GenerateProjectResponses,
  GetActivityData,
  GetActivityResponses,
  GetAppRegistrationAmendmentBaseData,
  GetAppRegistrationAmendmentBaseErrors,
  GetAppRegistrationAmendmentBaseResponses,
  GetHealthData,
  GetHealthResponses,
  GetMeData,
  GetMeDetailData,
  GetMeDetailResponses,
  GetMeResponses,
  GetProjectData,
  GetProjectErrors,
  GetProjectLogsData,
  GetProjectLogsErrors,
  GetProjectLogsResponses,
  GetProjectResourcesStatusData,
  GetProjectResourcesStatusErrors,
  GetProjectResourcesStatusResponses,
  GetProjectResponses,
  GetProjectServicesData,
  GetProjectServicesErrors,
  GetProjectServicesResponses,
  GetProjectSignInData,
  GetProjectSignInErrors,
  GetProjectSignInResponses,
  GetVersionData,
  GetVersionResponses,
  GithubCallbackData,
  GithubCallbackErrors,
  GithubCallbackResponses,
  GithubConnectData,
  GithubConnectResponses,
  GithubDisconnectData,
  GithubDisconnectResponses,
  GithubStatusData,
  GithubStatusResponses,
  InviteUserData,
  InviteUserErrors,
  InviteUserResponses,
  LinkLangfuseProjectData,
  LinkLangfuseProjectErrors,
  LinkLangfuseProjectResponses,
  ListAppRegistrationEnvironmentsData,
  ListAppRegistrationEnvironmentsErrors,
  ListAppRegistrationEnvironmentsResponses,
  ListAppRegistrationScopesData,
  ListAppRegistrationScopesResponses,
  ListGroupMembersData,
  ListGroupMembersErrors,
  ListGroupMembersResponses,
  ListGroupsData,
  ListGroupsResponses,
  ListMyGroupsData,
  ListMyGroupsResponses,
  ListPendingAppRegistrationRequestsData,
  ListPendingAppRegistrationRequestsResponses,
  ListProjectAppRegistrationRequestsData,
  ListProjectAppRegistrationRequestsErrors,
  ListProjectAppRegistrationRequestsResponses,
  ListProjectEnvironmentsData,
  ListProjectEnvironmentsErrors,
  ListProjectEnvironmentsResponses,
  ListProjectMembersData,
  ListProjectMembersErrors,
  ListProjectMembersResponses,
  ListProjectPromotionRequestsData,
  ListProjectPromotionRequestsErrors,
  ListProjectPromotionRequestsResponses,
  ListProjectsData,
  ListProjectsErrors,
  ListProjectsResponses,
  ListSignInApprovalsData,
  ListSignInApprovalsErrors,
  ListSignInApprovalsResponses,
  LogoutData,
  LogoutResponses,
  MarkSignInApprovedData,
  MarkSignInApprovedErrors,
  MarkSignInApprovedResponses,
  MigrateDeployIdentityData,
  MigrateDeployIdentityErrors,
  MigrateDeployIdentityResponses,
  PromoteProjectData,
  PromoteProjectErrors,
  PromoteProjectResponses,
  ReconcileAppRegistrationsData,
  ReconcileAppRegistrationsResponses,
  ReconcileEdgeData,
  ReconcileEdgeErrors,
  ReconcileEdgeResponses,
  RedeployProjectEnvironmentData,
  RedeployProjectEnvironmentErrors,
  RedeployProjectEnvironmentResponses,
  RejectAppRegistrationData,
  RejectAppRegistrationErrors,
  RejectAppRegistrationResponses,
  RemoveGroupMemberData,
  RemoveGroupMemberErrors,
  RemoveGroupMemberResponses,
  RemoveProjectMemberData,
  RemoveProjectMemberErrors,
  RemoveProjectMemberResponses,
  RequestAppRegistrationDecommissionData,
  RequestAppRegistrationDecommissionErrors,
  RequestAppRegistrationDecommissionResponses,
  RequestProjectPromotionData,
  RequestProjectPromotionErrors,
  RequestProjectPromotionResponses,
  RequestServiceBudgetData,
  RequestServiceBudgetErrors,
  RequestServiceBudgetResponses,
  SearchUsersData,
  SearchUsersErrors,
  SearchUsersResponses,
  SendTestNotificationData,
  SendTestNotificationResponses,
  StreamScaffoldEventsData,
  StreamScaffoldEventsErrors,
  StreamScaffoldEventsResponses,
  SyncEdgeTrustedIpsData,
  SyncEdgeTrustedIpsErrors,
  SyncEdgeTrustedIpsResponses,
  UnlinkProjectResourceData,
  UnlinkProjectResourceErrors,
  UnlinkProjectResourceResponses,
  UpdateGroupData,
  UpdateGroupErrors,
  UpdateGroupResponses,
  UpdateProfileData,
  UpdateProfileErrors,
  UpdateProfileResponses,
  UpdateProjectAppUrlData,
  UpdateProjectAppUrlErrors,
  UpdateProjectAppUrlResponses,
  UpdateProjectData,
  UpdateProjectErrors,
  UpdateProjectResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get Project Sign In
 *
 * How a project signs in and whether IT has approved each environment's registration.
 *
 * Visible to everyone who can see the project (the same rule as
 * ``getProject``): "waiting for IT approval" is what explains a sign-in that
 * does not work yet. The fallback reason and reconcile problems are directory
 * detail and go to the owner and admins only.
 */
export const getProjectSignIn = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectSignInData, ThrowOnError>,
): RequestResult<GetProjectSignInResponses, GetProjectSignInErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectSignInResponses, GetProjectSignInErrors, ThrowOnError>({
    url: "/projects/{project_id}/sign-in",
    ...options,
  });

/**
 * List Sign In Approvals
 *
 * The IT approval queue: sign-in registrations waiting for tenant-wide consent. Admin-only.
 *
 * Each entry carries a freshly signed admin-consent link; opening it as a
 * directory admin and accepting records the approval here automatically.
 */
export const listSignInApprovals = <ThrowOnError extends boolean = false>(
  options?: Options<ListSignInApprovalsData, ThrowOnError>,
): RequestResult<ListSignInApprovalsResponses, ListSignInApprovalsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListSignInApprovalsResponses,
    ListSignInApprovalsErrors,
    ThrowOnError
  >({ url: "/admin/sign-in-approvals", ...options });

/**
 * Check Sign In Approval
 *
 * Read the registration's grant from Graph and record consent if it is there. Admin-only.
 *
 * ``unknown`` when Scaffold UI is not allowed to read grants -- that is never
 * taken as consent; an admin who knows it was granted marks it by hand.
 */
export const checkSignInApproval = <ThrowOnError extends boolean = false>(
  options: Options<CheckSignInApprovalData, ThrowOnError>,
): RequestResult<CheckSignInApprovalResponses, CheckSignInApprovalErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CheckSignInApprovalResponses,
    CheckSignInApprovalErrors,
    ThrowOnError
  >({ url: "/admin/sign-in-approvals/{request_id}/check", ...options });

/**
 * Mark Sign In Approved
 *
 * Record consent by hand, for when IT granted it in the portal. Admin-only, audited.
 *
 * The fallback for a consent the redirect could not record (an expired link,
 * consent given from the portal) and a grant Scaffold UI is not allowed to
 * read. Only the record changes; consent itself happens in Entra.
 */
export const markSignInApproved = <ThrowOnError extends boolean = false>(
  options: Options<MarkSignInApprovedData, ThrowOnError>,
): RequestResult<MarkSignInApprovedResponses, MarkSignInApprovedErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MarkSignInApprovedResponses,
    MarkSignInApprovedErrors,
    ThrowOnError
  >({
    url: "/admin/sign-in-approvals/{request_id}/mark-approved",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send Test Notification
 *
 * Send one test approval email now and report what the mail service said. Admin-only.
 *
 * ``503`` while approval emails are off on this instance. Otherwise ``200``
 * with ``accepted`` (and the service's operation id and status), ``throttled``
 * (the hour's email budget is spent; nothing was sent) or ``failed`` (with
 * the service's error code). Never an address or a secret.
 */
export const sendTestNotification = <ThrowOnError extends boolean = false>(
  options?: Options<SendTestNotificationData, ThrowOnError>,
): RequestResult<SendTestNotificationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<SendTestNotificationResponses, unknown, ThrowOnError>({
    url: "/admin/notifications/test",
    ...options,
  });

/**
 * Get Project Services
 *
 * A gateway project's dev services: keys (never the key), limits, use, budget requests.
 *
 * Owner or admin. ``404`` for a project not on the services gateway. When the
 * key registry cannot answer, the services are empty and ``registry_error``
 * says why; the budget requests are still listed.
 */
export const getProjectServices = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectServicesData, ThrowOnError>,
): RequestResult<GetProjectServicesResponses, GetProjectServicesErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetProjectServicesResponses,
    GetProjectServicesErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/services", ...options });

/**
 * Request Service Budget
 *
 * Ask an admin for a new monthly budget for one service (owner or admin). Sets nothing.
 *
 * Requests for Serper and Langfuse, USD for the LLM (``422`` for the other
 * unit, or above what an admin may grant). ``409`` while a request for the
 * same service is open.
 */
export const requestServiceBudget = <ThrowOnError extends boolean = false>(
  options: Options<RequestServiceBudgetData, ThrowOnError>,
): RequestResult<RequestServiceBudgetResponses, RequestServiceBudgetErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RequestServiceBudgetResponses,
    RequestServiceBudgetErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/services/{service}/budget-requests",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Service Budget Requests
 *
 * The budget queue: open requests (oldest first), then the latest decided. Admin-only.
 */
export const adminListServiceBudgetRequests = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListServiceBudgetRequestsData, ThrowOnError>,
): RequestResult<AdminListServiceBudgetRequestsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminListServiceBudgetRequestsResponses, unknown, ThrowOnError>({
    url: "/admin/service-budget-requests",
    ...options,
  });

/**
 * Admin Approve Service Budget Request
 *
 * Approve a budget request: sets the budget in the key registry. Admin-only.
 *
 * The amount asked for, unless the body gives another (in the service's
 * unit, up to the cap). A registry failure leaves the request ``failed``;
 * approving again retries. Approving your own request (also one raised
 * through MCP) is allowed and recorded.
 */
export const adminApproveServiceBudgetRequest = <ThrowOnError extends boolean = false>(
  options: Options<AdminApproveServiceBudgetRequestData, ThrowOnError>,
): RequestResult<
  AdminApproveServiceBudgetRequestResponses,
  AdminApproveServiceBudgetRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminApproveServiceBudgetRequestResponses,
    AdminApproveServiceBudgetRequestErrors,
    ThrowOnError
  >({
    url: "/admin/service-budget-requests/{request_id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Reject Service Budget Request
 *
 * Reject a budget request with a note the requester reads. Admin-only.
 */
export const adminRejectServiceBudgetRequest = <ThrowOnError extends boolean = false>(
  options: Options<AdminRejectServiceBudgetRequestData, ThrowOnError>,
): RequestResult<
  AdminRejectServiceBudgetRequestResponses,
  AdminRejectServiceBudgetRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminRejectServiceBudgetRequestResponses,
    AdminRejectServiceBudgetRequestErrors,
    ThrowOnError
  >({
    url: "/admin/service-budget-requests/{request_id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Service Tier
 *
 * Set a service's rate-limit tier (``null``: the environment default). Admin-only.
 *
 * A tier the gateway does not know is refused by it (``422``).
 */
export const adminSetServiceTier = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetServiceTierData, ThrowOnError>,
): RequestResult<AdminSetServiceTierResponses, AdminSetServiceTierErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetServiceTierResponses,
    AdminSetServiceTierErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/services/{service}/tier",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Service Budget
 *
 * Set a service's monthly budget; both fields empty: the environment default. Admin-only.
 *
 * Above the instance's cap for the service, or the gateway's own ceiling: ``422``.
 */
export const adminSetServiceBudget = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetServiceBudgetData, ThrowOnError>,
): RequestResult<AdminSetServiceBudgetResponses, AdminSetServiceBudgetErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminSetServiceBudgetResponses,
    AdminSetServiceBudgetErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/services/{service}/budget",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Rotate Service Key
 *
 * Rotate a service's key: the new one goes to the repository, dev redeploys. Admin-only.
 *
 * The old key keeps working ``overlap_hours`` (default 24) so the running app
 * is not cut off before the redeploy lands. ``502`` when the new key could not
 * be written to GitHub (it is then unused: rotate again); ``409`` while
 * another key change for the project runs.
 */
export const adminRotateServiceKey = <ThrowOnError extends boolean = false>(
  options: Options<AdminRotateServiceKeyData, ThrowOnError>,
): RequestResult<AdminRotateServiceKeyResponses, AdminRotateServiceKeyErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminRotateServiceKeyResponses,
    AdminRotateServiceKeyErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/services/{service}/rotate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Revoke Service Key
 *
 * Revoke one of the project's keys now -- the emergency stop. Admin-only.
 *
 * The app's calls with it fail within about a minute; rotate to give it a new one.
 */
export const adminRevokeServiceKey = <ThrowOnError extends boolean = false>(
  options: Options<AdminRevokeServiceKeyData, ThrowOnError>,
): RequestResult<AdminRevokeServiceKeyResponses, AdminRevokeServiceKeyErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminRevokeServiceKeyResponses,
    AdminRevokeServiceKeyErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/services/keys/{key_id}/revoke",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Reissue Service Keys
 *
 * Issue every service's key again, write them and redeploy dev. Admin-only.
 *
 * For a project whose keys were never written (its warning) or may have
 * leaked: replaced keys keep working ``overlap_hours`` (0 stops them at
 * once). Skips Langfuse once a dedicated project is linked, and the LLM
 * while the project uses Foundry directly.
 */
export const adminReissueServiceKeys = <ThrowOnError extends boolean = false>(
  options: Options<AdminReissueServiceKeysData, ThrowOnError>,
): RequestResult<AdminReissueServiceKeysResponses, AdminReissueServiceKeysErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminReissueServiceKeysResponses,
    AdminReissueServiceKeysErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/services/reissue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Llm Mode
 *
 * Switch how the project's dev app reaches the models. Admin-only, logged.
 *
 * ``direct``: the app identity (and creator) get Foundry User first, then the
 * LLM key is removed and revoked, and dev redeploys. ``gateway``: a new LLM
 * key is written, dev redeploys, and that deploy's callback removes the app's
 * role. Deleting a GitHub secret by hand changes no role: only this does.
 */
export const adminSetLlmMode = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetLlmModeData, ThrowOnError>,
): RequestResult<AdminSetLlmModeResponses, AdminSetLlmModeErrors, ThrowOnError> =>
  (options.client ?? client).put<AdminSetLlmModeResponses, AdminSetLlmModeErrors, ThrowOnError>({
    url: "/projects/{project_id}/services/llm/mode",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Get Ai Services
 *
 * Every gateway project's use and spend this month, joined to Scaffold UI's record. Admin-only.
 *
 * ``404`` while ``SVC_GATEWAY_ENABLED`` is off. When the key registry cannot
 * answer, ``registry`` is empty and ``registry_error`` says why; Scaffold
 * UI's own counts (direct mode, overdue role removals, budget requests) are
 * there regardless.
 */
export const adminGetAiServices = <ThrowOnError extends boolean = false>(
  options?: Options<AdminGetAiServicesData, ThrowOnError>,
): RequestResult<AdminGetAiServicesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminGetAiServicesResponses, unknown, ThrowOnError>({
    url: "/admin/ai-services",
    ...options,
  });

/**
 * Admin Set Project Suspension
 *
 * Suspend or resume every service of a gateway project. Admin-only, logged.
 *
 * Its keys answer 403 ``suspended`` within about a minute; the owner sees the
 * reason. ``404`` for a project not on the gateway or unknown to the registry.
 */
export const adminSetProjectSuspension = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetProjectSuspensionData, ThrowOnError>,
): RequestResult<
  AdminSetProjectSuspensionResponses,
  AdminSetProjectSuspensionErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminSetProjectSuspensionResponses,
    AdminSetProjectSuspensionErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/services/suspension",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Service Suspension
 *
 * Suspend or resume one service of a gateway project. Admin-only, logged.
 *
 * ``404`` for a project not on the gateway, or a service it has no key for.
 */
export const adminSetServiceSuspension = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetServiceSuspensionData, ThrowOnError>,
): RequestResult<
  AdminSetServiceSuspensionResponses,
  AdminSetServiceSuspensionErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminSetServiceSuspensionResponses,
    AdminSetServiceSuspensionErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/services/{service}/suspension",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Set Service Kill Switch
 *
 * The kill switch: suspend or resume one service for every gateway project here. Admin-only.
 *
 * To suspend, ``confirm`` is the service's name (``422`` otherwise). Every
 * project's app loses that service within about a minute, until resumed.
 */
export const adminSetServiceKillSwitch = <ThrowOnError extends boolean = false>(
  options: Options<AdminSetServiceKillSwitchData, ThrowOnError>,
): RequestResult<
  AdminSetServiceKillSwitchResponses,
  AdminSetServiceKillSwitchErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminSetServiceKillSwitchResponses,
    AdminSetServiceKillSwitchErrors,
    ThrowOnError
  >({
    url: "/admin/ai-services/{service}/suspension",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Get Deploy Identity Scope Readiness
 *
 * The scope migration's prerequisites and every project's next step. Admin-only.
 *
 * Reads the database, the two custom roles, Scaffold UI's own RBAC
 * Administrator conditions and the candidates' branches; nothing per project
 * in Azure (that is the dry run).
 */
export const adminGetDeployIdentityScopeReadiness = <ThrowOnError extends boolean = false>(
  options?: Options<AdminGetDeployIdentityScopeReadinessData, ThrowOnError>,
): RequestResult<AdminGetDeployIdentityScopeReadinessResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminGetDeployIdentityScopeReadinessResponses,
    unknown,
    ThrowOnError
  >({ url: "/admin/deploy-identity/scope-migration", ...options });

/**
 * Admin Run Deploy Identity Scope Migration
 *
 * Dry-run (default), migrate or roll back one project's deploy identity scope. Admin-only.
 *
 * Migrate: grants on the project's own resource groups, read back, then the
 * subscription-wide Contributor and Storage Blob Data Contributor removed by
 * exact id; any failure puts back what this run removed. Rollback: the
 * subscription-wide grants again. ``force`` lets an unproven template
 * through; ``adopt`` names the environments whose unproven resource group or
 * existing state blob the admin vouches for. ``409`` while a redeploy,
 * promotion, teardown or identity migration of the project runs; ``422``
 * when a run that changes Azure does not confirm the repository name.
 * Otherwise the report's ``state`` says what happened (``blocked``: nothing
 * changed).
 */
export const adminRunDeployIdentityScopeMigration = <ThrowOnError extends boolean = false>(
  options: Options<AdminRunDeployIdentityScopeMigrationData, ThrowOnError>,
): RequestResult<
  AdminRunDeployIdentityScopeMigrationResponses,
  AdminRunDeployIdentityScopeMigrationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminRunDeployIdentityScopeMigrationResponses,
    AdminRunDeployIdentityScopeMigrationErrors,
    ThrowOnError
  >({
    url: "/admin/deploy-identity/scope-migration",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Health
 *
 * Return a simple health status payload.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
): RequestResult<GetHealthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Version
 *
 * Return the running backend version (sourced from pyproject.toml).
 *
 * Also says whether this instance gives new projects a public hostname, by
 * naming the domain they would get one under (``None`` when it does not).
 */
export const getVersion = <ThrowOnError extends boolean = false>(
  options?: Options<GetVersionData, ThrowOnError>,
): RequestResult<GetVersionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetVersionResponses, unknown, ThrowOnError>({
    url: "/version",
    ...options,
  });

/**
 * Auth Me
 *
 * Return the current user's profile.
 *
 * The user's email comes from the verified session cookie.
 *
 * Joins our ``users`` and ``profiles`` tables.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
): RequestResult<GetMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });

/**
 * Auth Me Detail
 *
 * Return the current user's profile with timeline fields.
 *
 * Includes ``created_at`` and ``last_active_at`` without requiring admin
 * privileges on the caller side — the endpoint authenticates via the
 * session cookie.
 */
export const getMeDetail = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeDetailData, ThrowOnError>,
): RequestResult<GetMeDetailResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetMeDetailResponses, unknown, ThrowOnError>({
    url: "/auth/me/detail",
    ...options,
  });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie. No authentication required.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
): RequestResult<LogoutResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Auth Update Profile
 *
 * Update the current user's first/last name.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProfileData, ThrowOnError>,
): RequestResult<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    url: "/auth/profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Activity
 *
 * Return the current user's activity log.
 */
export const getActivity = <ThrowOnError extends boolean = false>(
  options?: Options<GetActivityData, ThrowOnError>,
): RequestResult<GetActivityResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetActivityResponses, unknown, ThrowOnError>({
    url: "/auth/activity",
    ...options,
  });

/**
 * Admin List Users
 *
 * List all users. Admin only.
 *
 * Optional ``sort_by``/``sort_dir`` order the result server-side (see
 * ``_sorted_by``); omitting them keeps the natural order.
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListUsersData, ThrowOnError>,
): RequestResult<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError>({
    url: "/admin/users",
    ...options,
  });

/**
 * Admin Delete User
 *
 * Delete a user. Admin only.
 *
 * Cascades to profiles, activity_logs, github_connections, and projects
 * thanks to ON DELETE CASCADE — there is no separate identity store to
 * clean up (Entra owns the credential; we only own the local row).
 */
export const adminDeleteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteUserData, ThrowOnError>,
): RequestResult<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Get User
 *
 * Get a single user's profile and activity logs. Admin only.
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetUserData, ThrowOnError>,
): RequestResult<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Update User
 *
 * Update a user's profile (name, role). Admin only.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateUserData, ThrowOnError>,
): RequestResult<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError> =>
  (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Invite User
 *
 * Pre-authorize a new user by email. Admin only.
 *
 * Only @boardofinnovation.com emails are accepted. There is no invite
 * email or password to set — this just pre-creates the local ``users``/
 * ``profiles`` row (same shape Entra JIT-provisions on first sign-in, see
 * ``api/routers/auth_sso.py``) so the person is visible/addressable (e.g.
 * added to a project) before they've ever signed in. They get real access
 * the moment they sign in with Microsoft.
 */
export const adminInviteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminInviteUserData, ThrowOnError>,
): RequestResult<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError> =>
  (options.client ?? client).post<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError>({
    url: "/admin/invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Activity
 *
 * List activity across all users (admin only).
 *
 * Search, filtering, sorting, and pagination are all applied server-side by
 * ``list_recent_activity`` — the client sends params and renders the
 * results. Each row carries a window-function ``total_count`` so the client
 * can paginate without a second query.
 */
export const adminListActivity = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListActivityData, ThrowOnError>,
): RequestResult<AdminListActivityResponses, AdminListActivityErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminListActivityResponses,
    AdminListActivityErrors,
    ThrowOnError
  >({ url: "/admin/activity", ...options });

/**
 * Admin Activity Analytics
 *
 * Return aggregated activity analytics for the admin dashboard (admin only).
 */
export const adminActivityAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityAnalyticsData, ThrowOnError>,
): RequestResult<AdminActivityAnalyticsResponses, AdminActivityAnalyticsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminActivityAnalyticsResponses,
    AdminActivityAnalyticsErrors,
    ThrowOnError
  >({ url: "/admin/activity/analytics", ...options });

/**
 * Admin Activity Actions
 *
 * Return distinct activity actions across all time (admin only).
 *
 * Powers the activity filter dropdown so it matches the full, unbounded table
 * scope rather than the windowed analytics breakdown.
 */
export const adminActivityActions = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityActionsData, ThrowOnError>,
): RequestResult<AdminActivityActionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminActivityActionsResponses, unknown, ThrowOnError>({
    url: "/admin/activity/actions",
    ...options,
  });

/**
 * Admin Refresh Projects
 *
 * Validate all projects still exist on GitHub, reporting repos that are missing or not visible.
 *
 * Admin only. Uses the admin's GitHub token to check repo existence.
 * A 404 may indicate insufficient token visibility rather than a truly missing repo.
 *
 * When ``background=True`` (used by automatic frontend polling), activity
 * logging is skipped to avoid noisy logs and unnecessary DB writes.
 */
export const adminRefreshProjects = <ThrowOnError extends boolean = false>(
  options?: Options<AdminRefreshProjectsData, ThrowOnError>,
): RequestResult<AdminRefreshProjectsResponses, AdminRefreshProjectsErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    AdminRefreshProjectsResponses,
    AdminRefreshProjectsErrors,
    ThrowOnError
  >({ url: "/admin/projects/refresh", ...options });

/**
 * Admin Delete Project
 *
 * Delete a project record from the database (admin only).
 *
 * Unlike the owner-facing ``deleteProject``, this doesn't require the
 * GitHub repo to already be unlinked -- an admin force-delete is assumed to
 * mean every external resource is already gone or being cleaned up by hand.
 * Best-effort teardown (NOR-283) still runs first, since the Entra SSO
 * redirect URI and Azure resource group are Scaffold UI's own to clean up
 * regardless. Live desk app registrations are not deleted as a side effect:
 * see ``services/project_removal.force_delete_project``.
 */
export const adminDeleteProject = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteProjectData, ThrowOnError>,
): RequestResult<AdminDeleteProjectResponses, AdminDeleteProjectErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminDeleteProjectResponses,
    AdminDeleteProjectErrors,
    ThrowOnError
  >({
    url: "/admin/projects/{project_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Groups
 *
 * List all groups with their member counts. Admin only.
 */
export const listGroups = <ThrowOnError extends boolean = false>(
  options?: Options<ListGroupsData, ThrowOnError>,
): RequestResult<ListGroupsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListGroupsResponses, unknown, ThrowOnError>({
    url: "/admin/groups",
    ...options,
  });

/**
 * Admin Create Group
 *
 * Create a new group for scoping shared project visibility. Admin only.
 */
export const createGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateGroupData, ThrowOnError>,
): RequestResult<CreateGroupResponses, CreateGroupErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateGroupResponses, CreateGroupErrors, ThrowOnError>({
    url: "/admin/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Delete Group
 *
 * Delete a group. Admin only.
 *
 * Member projects are not deleted -- ``projects.group_id`` is ``ON DELETE
 * SET NULL``, so they fall back to ungrouped and stay visible to their owner
 * and explicit members (plus admins), not to everyone.
 */
export const deleteGroup = <ThrowOnError extends boolean = false>(
  options: Options<DeleteGroupData, ThrowOnError>,
): RequestResult<DeleteGroupResponses, DeleteGroupErrors, ThrowOnError> =>
  (options.client ?? client).delete<DeleteGroupResponses, DeleteGroupErrors, ThrowOnError>({
    url: "/admin/groups/{group_id}",
    ...options,
  });

/**
 * Admin Update Group
 *
 * Rename a group. Admin only.
 */
export const updateGroup = <ThrowOnError extends boolean = false>(
  options: Options<UpdateGroupData, ThrowOnError>,
): RequestResult<UpdateGroupResponses, UpdateGroupErrors, ThrowOnError> =>
  (options.client ?? client).patch<UpdateGroupResponses, UpdateGroupErrors, ThrowOnError>({
    url: "/admin/groups/{group_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Group Members
 *
 * List a group's members. Admin only.
 */
export const listGroupMembers = <ThrowOnError extends boolean = false>(
  options: Options<ListGroupMembersData, ThrowOnError>,
): RequestResult<ListGroupMembersResponses, ListGroupMembersErrors, ThrowOnError> =>
  (options.client ?? client).get<ListGroupMembersResponses, ListGroupMembersErrors, ThrowOnError>({
    url: "/admin/groups/{group_id}/members",
    ...options,
  });

/**
 * Admin Add Group Member
 *
 * Add a user to a group by id. Admin only.
 */
export const addGroupMember = <ThrowOnError extends boolean = false>(
  options: Options<AddGroupMemberData, ThrowOnError>,
): RequestResult<AddGroupMemberResponses, AddGroupMemberErrors, ThrowOnError> =>
  (options.client ?? client).post<AddGroupMemberResponses, AddGroupMemberErrors, ThrowOnError>({
    url: "/admin/groups/{group_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Remove Group Member
 *
 * Remove a user from a group. Admin only.
 */
export const removeGroupMember = <ThrowOnError extends boolean = false>(
  options: Options<RemoveGroupMemberData, ThrowOnError>,
): RequestResult<RemoveGroupMemberResponses, RemoveGroupMemberErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RemoveGroupMemberResponses,
    RemoveGroupMemberErrors,
    ThrowOnError
  >({ url: "/admin/groups/{group_id}/members/{user_id}", ...options });

/**
 * Search Users
 *
 * Search users by name or email for the member-add combobox.
 *
 * Authenticated (not admin-only). Returns up to 20 matching confirmed users.
 * ``exclude`` is a comma-separated list of user IDs to exclude.
 */
export const searchUsers = <ThrowOnError extends boolean = false>(
  options?: Options<SearchUsersData, ThrowOnError>,
): RequestResult<SearchUsersResponses, SearchUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<SearchUsersResponses, SearchUsersErrors, ThrowOnError>({
    url: "/users/search",
    ...options,
  });

/**
 * Invite User
 *
 * Pre-authorize a colleague by email. Any authenticated user can call this.
 *
 * Only @boardofinnovation.com emails are accepted. There is no invite email
 * or password to set — this just pre-creates the local ``users``/``profiles``
 * row (same shape Entra JIT-provisions on first sign-in, see
 * ``api/routers/auth_sso.py``) so the person can be found in search and
 * added to a project before they've ever signed in. They get real access
 * the moment they sign in with Microsoft.
 */
export const inviteUser = <ThrowOnError extends boolean = false>(
  options: Options<InviteUserData, ThrowOnError>,
): RequestResult<InviteUserResponses, InviteUserErrors, ThrowOnError> =>
  (options.client ?? client).post<InviteUserResponses, InviteUserErrors, ThrowOnError>({
    url: "/users/invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Github Connect
 *
 * Return the GitHub OAuth authorization URL.
 *
 * The ``state`` parameter is an HMAC of the user's email to prevent CSRF.
 */
export const githubConnect = <ThrowOnError extends boolean = false>(
  options?: Options<GithubConnectData, ThrowOnError>,
): RequestResult<GithubConnectResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GithubConnectResponses, unknown, ThrowOnError>({
    url: "/github/connect",
    ...options,
  });

/**
 * Github Callback
 *
 * Exchange the GitHub OAuth code for an access token and store it.
 */
export const githubCallback = <ThrowOnError extends boolean = false>(
  options: Options<GithubCallbackData, ThrowOnError>,
): RequestResult<GithubCallbackResponses, GithubCallbackErrors, ThrowOnError> =>
  (options.client ?? client).post<GithubCallbackResponses, GithubCallbackErrors, ThrowOnError>({
    url: "/github/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Github Status
 *
 * Check whether the current user has a GitHub connection stored.
 *
 * Also probes the configured GitHub org so the homepage can warn users
 * who are not members, and reports whether GitHub OAuth is configured on
 * this instance at all (a keyless instance can't connect anyone, NOR-467).
 */
export const githubStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GithubStatusData, ThrowOnError>,
): RequestResult<GithubStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GithubStatusResponses, unknown, ThrowOnError>({
    url: "/github/status",
    ...options,
  });

/**
 * Github Disconnect
 *
 * Remove the current user's GitHub connection.
 */
export const githubDisconnect = <ThrowOnError extends boolean = false>(
  options?: Options<GithubDisconnectData, ThrowOnError>,
): RequestResult<GithubDisconnectResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).delete<GithubDisconnectResponses, unknown, ThrowOnError>({
    url: "/github/disconnect",
    ...options,
  });

/**
 * List My Groups
 *
 * List the groups the current user belongs to.
 *
 * Powers the create-project group picker and the project list filter --
 * the caller only ever needs their own memberships, never every group in
 * the system (that's the admin-only ``listGroups``).
 */
export const listMyGroups = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyGroupsData, ThrowOnError>,
): RequestResult<ListMyGroupsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListMyGroupsResponses, unknown, ThrowOnError>({
    url: "/me/groups",
    ...options,
  });

/**
 * List Projects
 *
 * List the current user's scaffold projects.
 *
 * Optional ``sort_by``/``sort_dir`` order the result server-side (see
 * ``_sorted_by``); omitting them keeps the natural order.
 */
export const listProjects = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectsData, ThrowOnError>,
): RequestResult<ListProjectsResponses, ListProjectsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListProjectsResponses, ListProjectsErrors, ThrowOnError>({
    url: "/projects",
    ...options,
  });

/**
 * Create Project
 *
 * Create a new scaffold project and start the background pipeline.
 *
 * Every check and side effect lives in ``services/project_creation``, shared
 * with the MCP ``create_project`` tool.
 */
export const createProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectData, ThrowOnError>,
): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    url: "/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Project
 *
 * Delete a project record (owner only). All resources must be removed first.
 */
export const deleteProject = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectData, ThrowOnError>,
): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> =>
  (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    url: "/projects/{project_id}",
    ...options,
  });

/**
 * Get Project
 *
 * Get a single project by ID (for status checking).
 */
export const getProject = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectData, ThrowOnError>,
): RequestResult<GetProjectResponses, GetProjectErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    url: "/projects/{project_id}",
    ...options,
  });

/**
 * Update Project
 *
 * Reassign a project's group after creation (owner or admin only).
 *
 * Mirrors ``createProject``'s group-authorization semantics: a non-``None``
 * ``group_id`` must reference an existing group, and a non-admin owner may
 * only assign a group they belong to (admins may assign any group).
 * ``group_id = None`` (back to ungrouped -- owner and explicit members
 * only) is always allowed.
 * Ownership is enforced by ``authz.verify_project_owner`` (admins bypass it).
 */
export const updateProject = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectData, ThrowOnError>,
): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> =>
  (options.client ?? client).patch<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    url: "/projects/{project_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Project Environments
 *
 * List a project's promoted environments (`test`/`prod` -- no row for `dev`).
 *
 * Same visibility as ``getProject``: an admin can view any project, a
 * regular user only what ``get_project`` already lets them see.
 */
export const listProjectEnvironments = <ThrowOnError extends boolean = false>(
  options: Options<ListProjectEnvironmentsData, ThrowOnError>,
): RequestResult<ListProjectEnvironmentsResponses, ListProjectEnvironmentsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListProjectEnvironmentsResponses,
    ListProjectEnvironmentsErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/environments", ...options });

/**
 * Promote Project
 *
 * Promote a project to ``test`` (off ``dev``) or ``prod`` (off ``test``). Admin-only.
 *
 * Ordering is enforced: ``test`` requires the project's dev scaffold to be
 * ``completed``; ``prod`` requires a prior ``test`` promotion recorded with
 * ``status="promoted"``. Re-promoting an already-promoted environment is
 * always allowed -- every pipeline step is idempotent, and re-running is
 * how an admin recovers from a partial failure (see ``services/promote.py``).
 * Runs as the *project owner's* GitHub identity, not the acting admin's,
 * mirroring ``deleteProjectGithub``.
 */
export const promoteProject = <ThrowOnError extends boolean = false>(
  options: Options<PromoteProjectData, ThrowOnError>,
): RequestResult<PromoteProjectResponses, PromoteProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<PromoteProjectResponses, PromoteProjectErrors, ThrowOnError>({
    url: "/projects/{project_id}/promote",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Project Promotion Requests
 *
 * A project's promotion requests, newest first (owner or admin).
 */
export const listProjectPromotionRequests = <ThrowOnError extends boolean = false>(
  options: Options<ListProjectPromotionRequestsData, ThrowOnError>,
): RequestResult<
  ListProjectPromotionRequestsResponses,
  ListProjectPromotionRequestsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListProjectPromotionRequestsResponses,
    ListProjectPromotionRequestsErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/promotion-requests", ...options });

/**
 * Request Project Promotion
 *
 * Ask an admin to promote a project (owner or admin). Promotes nothing by itself.
 *
 * Refused (409) out of order or while a request for the same target is
 * open. An admin approves it in Admin > Promotion requests, which runs the
 * same promotion as ``promoteProject``. See ``services/project_promotion``.
 */
export const requestProjectPromotion = <ThrowOnError extends boolean = false>(
  options: Options<RequestProjectPromotionData, ThrowOnError>,
): RequestResult<RequestProjectPromotionResponses, RequestProjectPromotionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RequestProjectPromotionResponses,
    RequestProjectPromotionErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/promotion-requests",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Promotion Requests
 *
 * The promotion queue: open requests (oldest first), then the latest decided. Admin-only.
 */
export const adminListPromotionRequests = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListPromotionRequestsData, ThrowOnError>,
): RequestResult<AdminListPromotionRequestsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AdminListPromotionRequestsResponses, unknown, ThrowOnError>({
    url: "/admin/promotion-requests",
    ...options,
  });

/**
 * Admin Approve Promotion Request
 *
 * Approve a promotion request: runs the promotion as ``promoteProject`` does. Admin-only.
 *
 * A pipeline failure leaves the request ``failed`` (502 with the reason);
 * approving again retries. Approving your own request is allowed and recorded.
 */
export const adminApprovePromotionRequest = <ThrowOnError extends boolean = false>(
  options: Options<AdminApprovePromotionRequestData, ThrowOnError>,
): RequestResult<
  AdminApprovePromotionRequestResponses,
  AdminApprovePromotionRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminApprovePromotionRequestResponses,
    AdminApprovePromotionRequestErrors,
    ThrowOnError
  >({
    url: "/admin/promotion-requests/{request_id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Reject Promotion Request
 *
 * Reject a promotion request with a note the requester reads. Admin-only.
 */
export const adminRejectPromotionRequest = <ThrowOnError extends boolean = false>(
  options: Options<AdminRejectPromotionRequestData, ThrowOnError>,
): RequestResult<
  AdminRejectPromotionRequestResponses,
  AdminRejectPromotionRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminRejectPromotionRequestResponses,
    AdminRejectPromotionRequestErrors,
    ThrowOnError
  >({
    url: "/admin/promotion-requests/{request_id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Redeploy Project Environment
 *
 * Re-run a deployed environment's deploy workflow from its branch (owner or admin).
 *
 * For a project whose resource groups Scaffold UI creates
 * (``deploy_identity_scope = 'resource_group'``) the environment's resource
 * group and its deploy identity's grants are ensured first -- how such an
 * environment comes back after an Azure-only teardown. A group still being
 * deleted, or one that is not the project's, is a 409.
 */
export const redeployProjectEnvironment = <ThrowOnError extends boolean = false>(
  options: Options<RedeployProjectEnvironmentData, ThrowOnError>,
): RequestResult<
  RedeployProjectEnvironmentResponses,
  RedeployProjectEnvironmentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RedeployProjectEnvironmentResponses,
    RedeployProjectEnvironmentErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/environments/{environment}/redeploy", ...options });

/**
 * Link Langfuse Project
 *
 * Link a project to its own dedicated Langfuse project (NOR-477). Admin-only, AI projects only.
 *
 * Verifies the pasted key pair against Langfuse itself, writes them as the
 * repo's ``LANGFUSE_*`` secrets (replacing the shared sandbox keys -- see
 * ``services/github.set_langfuse_secrets``), persists the linked project's
 * name/timestamp, then best-effort redeploys ``dev`` plus every promoted
 * ``test``/``prod`` environment so Terraform pushes the new keys into each
 * environment's Key Vault. Idempotent: linking again (rotating keys)
 * overwrites the previous link. Runs as the project owner's GitHub
 * identity, mirroring ``promote_project``.
 *
 * Every purely local check (project exists, is AI-enabled, key prefixes, repo
 * linked, owner's GitHub credentials usable) runs *before* the call out to
 * Langfuse, so a request that cannot possibly succeed never reaches it.
 */
export const linkLangfuseProject = <ThrowOnError extends boolean = false>(
  options: Options<LinkLangfuseProjectData, ThrowOnError>,
): RequestResult<LinkLangfuseProjectResponses, LinkLangfuseProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<
    LinkLangfuseProjectResponses,
    LinkLangfuseProjectErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/langfuse",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Migrate Deploy Identity
 *
 * Move a legacy project off the shared deploy identity onto its own (NOR-471). Admin-only.
 *
 * Holds the project's lifecycle lock without waiting (409 while a redeploy,
 * promotion, teardown or the deploy identity scope migration of the project
 * runs): its re-sync grants Contributor on whole subscriptions, which must
 * not land in the middle of the scope migration taking them away.
 */
export const migrateDeployIdentity = <ThrowOnError extends boolean = false>(
  options: Options<MigrateDeployIdentityData, ThrowOnError>,
): RequestResult<MigrateDeployIdentityResponses, MigrateDeployIdentityErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MigrateDeployIdentityResponses,
    MigrateDeployIdentityErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/deploy-identity/migrate", ...options });

/**
 * Update Project App Url
 *
 * Store the outcome of the scaffolded repo's own deploy workflow.
 *
 * Called by the scaffolded app's ``deploy.yml`` — not the browser — so it
 * authenticates via the ``X-Scaffold-Token`` header (matched against the
 * per-project hash minted at scaffold time) instead of the session cookie.
 *
 * The workflow runs this step with ``if: always()`` (NOR-456), so the call
 * also arrives for a *failed* deploy: ``status="failed"`` with the failing
 * run's ``run_url`` and no ``app_url``, since nothing was deployed. That
 * outcome is recorded (on the project for ``dev``, on the environment's own
 * row for ``test``/``prod``) and nothing else is done: the Entra
 * redirect-URI registration and the Foundry provisioning below both act on a
 * freshly deployed app that, this time, does not exist.
 */
export const updateProjectAppUrl = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectAppUrlData, ThrowOnError>,
): RequestResult<UpdateProjectAppUrlResponses, UpdateProjectAppUrlErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdateProjectAppUrlResponses,
    UpdateProjectAppUrlErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/app-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reconcile Project Edge
 *
 * Reconcile one environment's edge now and return where it stands. Admin-only.
 *
 * The background reconciler does this by itself every minute, and retries a
 * ``failed`` environment with a growing delay. This runs one pass at once,
 * ignoring that delay: for an admin who fixed whatever was wrong and does
 * not want to wait. It waits up to half a minute for the reconciler's lock
 * (a background pass or a teardown changing the instance's WAF binding) and
 * answers 409 when that is still held.
 */
export const reconcileEdge = <ThrowOnError extends boolean = false>(
  options: Options<ReconcileEdgeData, ThrowOnError>,
): RequestResult<ReconcileEdgeResponses, ReconcileEdgeErrors, ThrowOnError> =>
  (options.client ?? client).post<ReconcileEdgeResponses, ReconcileEdgeErrors, ThrowOnError>({
    url: "/projects/{project_id}/edge/{environment}/reconcile",
    ...options,
  });

/**
 * Sync Edge Trusted Ips
 *
 * Sync the WAF trusted-IP list from the trusted Entra named locations now. Admin-only.
 *
 * An instance with the sync switched on does this by itself every hour. This is for an admin
 * who just changed a named location and does not want to wait, and the one
 * way through the guard against a run that removes more than half of the
 * ranges at once (``allow_large_removal``). 409 on an instance that does not
 * own the list, 422 when the new list is refused, 502 when Graph or ARM fail.
 */
export const syncEdgeTrustedIps = <ThrowOnError extends boolean = false>(
  options?: Options<SyncEdgeTrustedIpsData, ThrowOnError>,
): RequestResult<SyncEdgeTrustedIpsResponses, SyncEdgeTrustedIpsErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    SyncEdgeTrustedIpsResponses,
    SyncEdgeTrustedIpsErrors,
    ThrowOnError
  >({ url: "/edge/trusted-ips/sync", ...options });

/**
 * Cancel Project Scaffold
 *
 * Cancel a running scaffold for a project (owner only).
 *
 * The scaffold may run on another backend replica, so the cancel is recorded
 * on the project (``scaffold_cancel_requested_at``) while it is not finished:
 * the replica running it notices within seconds and cancels its task, and
 * the scaffold reads it again before it creates a resource group. A task
 * running in this process is cancelled at once as well. ``409`` when
 * nothing is being created.
 */
export const cancelProjectScaffold = <ThrowOnError extends boolean = false>(
  options: Options<CancelProjectScaffoldData, ThrowOnError>,
): RequestResult<CancelProjectScaffoldResponses, CancelProjectScaffoldErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CancelProjectScaffoldResponses,
    CancelProjectScaffoldErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/cancel", ...options });

/**
 * Download Project Env
 *
 * Return the stored .env file content for a project.
 *
 * Only accessible by project owners/members. The env vars are stored
 * Fernet-encrypted and decrypted on read. An optional ``slug`` query param
 * names the downloaded file (``{slug}.env``).
 */
export const downloadProjectEnv = <ThrowOnError extends boolean = false>(
  options: Options<DownloadProjectEnvData, ThrowOnError>,
): RequestResult<DownloadProjectEnvResponses, DownloadProjectEnvErrors, ThrowOnError> =>
  (options.client ?? client).get<
    DownloadProjectEnvResponses,
    DownloadProjectEnvErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/env", ...options });

/**
 * Download Project Instructions
 *
 * Return the stored INSTRUCTIONS.md content for a project.
 *
 * Only accessible by project owners/members. The instructions are stored
 * Fernet-encrypted and decrypted on read.
 */
export const downloadProjectInstructions = <ThrowOnError extends boolean = false>(
  options: Options<DownloadProjectInstructionsData, ThrowOnError>,
): RequestResult<
  DownloadProjectInstructionsResponses,
  DownloadProjectInstructionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    DownloadProjectInstructionsResponses,
    DownloadProjectInstructionsErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/instructions", ...options });

/**
 * Get Project Logs
 *
 * Return persisted build logs for a project.
 */
export const getProjectLogs = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectLogsData, ThrowOnError>,
): RequestResult<GetProjectLogsResponses, GetProjectLogsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetProjectLogsResponses, GetProjectLogsErrors, ThrowOnError>({
    url: "/projects/{project_id}/logs",
    ...options,
  });

/**
 * Stream Scaffold Events
 *
 * SSE endpoint streaming scaffold progress events.
 */
export const streamScaffoldEvents = <ThrowOnError extends boolean = false>(
  options: Options<StreamScaffoldEventsData, ThrowOnError>,
): RequestResult<StreamScaffoldEventsResponses, StreamScaffoldEventsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    StreamScaffoldEventsResponses,
    StreamScaffoldEventsErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/events", ...options });

/**
 * Generate Project
 *
 * Generate project fields from a natural language description using AI.
 */
export const generateProject = <ThrowOnError extends boolean = false>(
  options: Options<GenerateProjectData, ThrowOnError>,
): RequestResult<GenerateProjectResponses, GenerateProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<GenerateProjectResponses, GenerateProjectErrors, ThrowOnError>({
    url: "/projects/generate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Project Members
 *
 * List members of a project.
 */
export const listProjectMembers = <ThrowOnError extends boolean = false>(
  options: Options<ListProjectMembersData, ThrowOnError>,
): RequestResult<ListProjectMembersResponses, ListProjectMembersErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListProjectMembersResponses,
    ListProjectMembersErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/members", ...options });

/**
 * Add Project Member
 *
 * Add a member to a project by email (owner or admin).
 */
export const addProjectMember = <ThrowOnError extends boolean = false>(
  options: Options<AddProjectMemberData, ThrowOnError>,
): RequestResult<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError> =>
  (options.client ?? client).post<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError>({
    url: "/projects/{project_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove Project Member
 *
 * Remove a member from a project (owner or admin).
 */
export const removeProjectMember = <ThrowOnError extends boolean = false>(
  options: Options<RemoveProjectMemberData, ThrowOnError>,
): RequestResult<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RemoveProjectMemberResponses,
    RemoveProjectMemberErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/members/{member_user_id}", ...options });

/**
 * Get Project Resources Status
 *
 * Check the live status of a project's external resources.
 *
 * Returns ``{"github": "active"|"missing"|"unlinked"|"error",
 * "azure": "active"|"deleting"|"missing"|"not_configured"|"error"}``.
 * "unlinked" means the URL is already null in our DB; "deleting" means a
 * teardown is in progress (the RG still exists but is being removed);
 * "not_configured" means no Azure subscription is set up to check against
 * (NOR-283/NOR-295).
 */
export const getProjectResourcesStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectResourcesStatusData, ThrowOnError>,
): RequestResult<
  GetProjectResourcesStatusResponses,
  GetProjectResourcesStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetProjectResourcesStatusResponses,
    GetProjectResourcesStatusErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/status", ...options });

/**
 * Delete Project Github
 *
 * Delete the GitHub repository for a project (owner only).
 */
export const deleteProjectGithub = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectGithubData, ThrowOnError>,
): RequestResult<DeleteProjectGithubResponses, DeleteProjectGithubErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteProjectGithubResponses,
    DeleteProjectGithubErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/github", ...options });

/**
 * Delete Project Azure
 *
 * Tear down a project's Azure footprint (owner only): NOR-295.
 *
 * Reuses the same best-effort teardown as full project deletion (NOR-283),
 * keeping the project record, its deploy identity, edge names, Entra groups
 * and sign-in registrations so it can simply be redeployed. A partial failure
 * is ``success=False`` with the combined errors. See
 * ``services/project_removal.teardown_azure``.
 */
export const deleteProjectAzure = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectAzureData, ThrowOnError>,
): RequestResult<DeleteProjectAzureResponses, DeleteProjectAzureErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteProjectAzureResponses,
    DeleteProjectAzureErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/azure", ...options });

/**
 * Unlink Project Resource
 *
 * Unlink a resource from a project without deleting it externally (owner/admin only).
 *
 * Use this when the resource was already deleted manually or the automated
 * deletion failed.  Only nulls the URL columns in the database.
 */
export const unlinkProjectResource = <ThrowOnError extends boolean = false>(
  options: Options<UnlinkProjectResourceData, ThrowOnError>,
): RequestResult<UnlinkProjectResourceResponses, UnlinkProjectResourceErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UnlinkProjectResourceResponses,
    UnlinkProjectResourceErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/resources/{resource_type}/unlink", ...options });

/**
 * List App Registration Scopes
 *
 * The delegated permissions a request may ask for, in picker order.
 *
 * Signed-in callers only -- it is not secret (every id here is a published
 * Microsoft identifier) but there is no reason to serve it to the world.
 *
 * This exists so the risk ratings and descriptions have exactly one home. The
 * frontend briefly carried its own transcription of the 36 entries, which
 * works right up until the catalogue changes and a scope reads `low` on the
 * screen while the server treats it as `high`.
 */
export const listAppRegistrationScopes = <ThrowOnError extends boolean = false>(
  options?: Options<ListAppRegistrationScopesData, ThrowOnError>,
): RequestResult<ListAppRegistrationScopesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ListAppRegistrationScopesResponses, unknown, ThrowOnError>({
    url: "/app-registration-scopes",
    ...options,
  });

/**
 * List App Registration Environments
 *
 * Which environments of this project can take an app registration.
 *
 * Postgres only, the same source and for the same reason as
 * `app_registration_desk.verify_environment_is_deployed`: the deployed URL and the managed
 * identity are created by one deploy, so a recorded URL answers both
 * questions without an ARM round trip on a form.
 *
 * An environment already holding a live registration is reported as
 * ``taken`` rather than omitted. The unique index would refuse the insert
 * anyway; saying so on the form turns a 409 nobody expects into a disabled
 * option with a reason next to it. A *decommissioned* registration does not
 * hold its environment -- the index stopped counting it (migration 0028) and
 * so does this, or taking a registration away would be a one-way door.
 */
export const listAppRegistrationEnvironments = <ThrowOnError extends boolean = false>(
  options: Options<ListAppRegistrationEnvironmentsData, ThrowOnError>,
): RequestResult<
  ListAppRegistrationEnvironmentsResponses,
  ListAppRegistrationEnvironmentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAppRegistrationEnvironmentsResponses,
    ListAppRegistrationEnvironmentsErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/app-registration-environments", ...options });

/**
 * List Project App Registration Requests
 *
 * List a project's app registration requests (owner or admin).
 *
 * Same gate as creating one: a request names the permissions an app is
 * asking for and the reason it wants them, which is not something every
 * member of a project's group needs to read.
 */
export const listProjectAppRegistrationRequests = <ThrowOnError extends boolean = false>(
  options: Options<ListProjectAppRegistrationRequestsData, ThrowOnError>,
): RequestResult<
  ListProjectAppRegistrationRequestsResponses,
  ListProjectAppRegistrationRequestsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListProjectAppRegistrationRequestsResponses,
    ListProjectAppRegistrationRequestsErrors,
    ThrowOnError
  >({ url: "/projects/{project_id}/app-registration-requests", ...options });

/**
 * Create App Registration Request
 *
 * Request an Entra app registration for a project (owner or admin).
 *
 * The project is the path parameter the caller was already authorized
 * against, and the `NO-AR-<Project>-<ENV>` display name is derived from that
 * project's own row -- neither is client-supplied. See
 * ``services/app_registration_desk.request_app_registration``.
 */
export const createAppRegistrationRequest = <ThrowOnError extends boolean = false>(
  options: Options<CreateAppRegistrationRequestData, ThrowOnError>,
): RequestResult<
  CreateAppRegistrationRequestResponses,
  CreateAppRegistrationRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAppRegistrationRequestResponses,
    CreateAppRegistrationRequestErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/app-registration-requests",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Pending App Registration Requests
 *
 * The approver queue: every request awaiting a decision or a retry. Admin-only.
 *
 * `AdminDep` is the whole authorization story, and it is deliberately the
 * strict one: this returns every request across every project -- other
 * people's requesters, purposes and permission lists included. There is no
 * `mine` / `all` parameter, so nothing the client sends widens what comes
 * back.
 */
export const listPendingAppRegistrationRequests = <ThrowOnError extends boolean = false>(
  options?: Options<ListPendingAppRegistrationRequestsData, ThrowOnError>,
): RequestResult<ListPendingAppRegistrationRequestsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    ListPendingAppRegistrationRequestsResponses,
    unknown,
    ThrowOnError
  >({ url: "/app-registration-requests", ...options });

/**
 * Approve App Registration Request
 *
 * Approve a request and provision the app registration. Admin-only.
 *
 * Three rules do the real work here:
 *
 * 1. **Approving your own request is allowed and recorded.** Every approver
 * is an admin (`AdminDep`); `self_approved` and the surface that raised
 * the request (`request_via`: `ui` or `mcp`) go on the activity entry, so
 * a self-approval -- including one
 * of a request Claude raised through MCP -- is never silent. The admin UI
 * warns before approving a request you raised through Claude.
 * 2. **A failed provisioning run never costs the approval.** The decision is
 * written and committed *before* the first Graph call, so a failure leaves
 * the row `failed`-with-an-error rather than rolling the approval back.
 * Approving again resumes provisioning from wherever it stopped (the
 * stored Entra ids are resume markers) instead of needing a second human
 * decision or creating duplicate objects. The original approver, note and
 * timestamp survive that retry -- a retry is not a new decision.
 * 3. **A request can only be claimed once.** The status check is the claim
 * itself (`claim_app_registration_request`), not the read below: two
 * approvers working the queue would both pass a pre-check and both spend
 * the whole Graph round-trip on a row still marked `pending`, ending with
 * two applications, two service principals and two secrets, one of them
 * orphaned live in the tenant. The read only buys a better error message
 * for the terminal states; the `None` from the claim is authoritative.
 * 4. **It holds the project's lifecycle lock** from the claim to the last
 * write (`project_resource_group.project_lifecycle_lock`, not waited for:
 * a busy project is a 409 and nothing is claimed). A project delete holds
 * the same lock across its final registration check and the row's delete,
 * so an application can never be created in Entra after that check and
 * then lose its row to the cascade.
 */
export const approveAppRegistration = <ThrowOnError extends boolean = false>(
  options: Options<ApproveAppRegistrationData, ThrowOnError>,
): RequestResult<ApproveAppRegistrationResponses, ApproveAppRegistrationErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ApproveAppRegistrationResponses,
    ApproveAppRegistrationErrors,
    ThrowOnError
  >({
    url: "/app-registration-requests/{request_id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get App Registration Amendment Base
 *
 * What an amendment to this registration would start from (owner or admin).
 *
 * The permissions an issued registration holds are not a column -- they are
 * the last provisioned `create` or `amend` row of its chain (migration 0020).
 * Serving that derivation instead of letting the form reimplement it is the
 * point: the value the requester edits is echoed back as `base_scope_keys` on
 * submit and compared with the server's own answer, so two implementations of
 * "which row wins" would be two chances for that compare-and-swap to pass
 * while comparing different things.
 *
 * Answers for any row in the chain, not only the root -- a requester clicking
 * an amendment means the registration it belongs to.
 */
export const getAppRegistrationAmendmentBase = <ThrowOnError extends boolean = false>(
  options: Options<GetAppRegistrationAmendmentBaseData, ThrowOnError>,
): RequestResult<
  GetAppRegistrationAmendmentBaseResponses,
  GetAppRegistrationAmendmentBaseErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAppRegistrationAmendmentBaseResponses,
    GetAppRegistrationAmendmentBaseErrors,
    ThrowOnError
  >({ url: "/app-registration-requests/{request_id}/amendment", ...options });

/**
 * Create App Registration Amendment
 *
 * Ask to change an issued registration's delegated permissions (owner or admin).
 *
 * Raises a sibling row; an approver decides it through the same approve /
 * reject endpoints as any other request, and approving is what reaches Entra.
 * Three refusals are 409s over a well-formed request (not amendable, stale
 * base, lost the insert race); a request that changes nothing is a 422.
 * See ``services/app_registration_desk.request_amendment``.
 */
export const createAppRegistrationAmendment = <ThrowOnError extends boolean = false>(
  options: Options<CreateAppRegistrationAmendmentData, ThrowOnError>,
): RequestResult<
  CreateAppRegistrationAmendmentResponses,
  CreateAppRegistrationAmendmentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAppRegistrationAmendmentResponses,
    CreateAppRegistrationAmendmentErrors,
    ThrowOnError
  >({
    url: "/app-registration-requests/{request_id}/amendments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Request App Registration Decommission
 *
 * Ask for a live desk app registration to be deleted (owner or admin).
 *
 * Creates a `delete` sibling row against the original request. Nothing is
 * removed from Entra here -- this is the *ask*; an approver working the same
 * queue as every other request carries it out. That split is the whole point:
 * deleting an application is irreversible for the deployment using it, so it
 * gets a named approver rather than a button. The website only: no MCP tool
 * raises a decommission. See
 * ``services/app_registration_desk.request_decommission``.
 */
export const requestAppRegistrationDecommission = <ThrowOnError extends boolean = false>(
  options: Options<RequestAppRegistrationDecommissionData, ThrowOnError>,
): RequestResult<
  RequestAppRegistrationDecommissionResponses,
  RequestAppRegistrationDecommissionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RequestAppRegistrationDecommissionResponses,
    RequestAppRegistrationDecommissionErrors,
    ThrowOnError
  >({
    url: "/projects/{project_id}/app-registration-requests/{request_id}/decommission",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reject App Registration Request
 *
 * Reject a pending request, with a reason the requester will read. Admin-only.
 *
 * Terminal: unlike a failed provisioning run, a rejection is a decision and
 * there is nothing to retry. Rejecting your own request -- a creation, a
 * permission change or a decommission, raised in the UI or through MCP -- is
 * allowed and logged
 * as ``self_rejected``, the same treatment self-approval gets: with a sole
 * admin, a request nobody else can decide would otherwise hold its slot
 * forever. Rejecting widens nothing.
 *
 * **Rejecting a `failed` sibling can leave Entra ahead of the record.** An
 * amendment applies its change in one ``PATCH``; if that call lands and the
 * response times out, or the commit after it fails, the row is stamped
 * `failed` while the application already holds the new permissions.
 * Approving again reconciles the two -- the write is idempotent against
 * Entra, so the retry sees ``live == target`` and just records it. Rejecting
 * instead ends the chain with the desk recording the *pre*-amendment set, and
 * every later amendment is then refused as drift until a human restores the
 * application by hand.
 *
 * It is still allowed, deliberately. A sibling holds no
 * ``(project_id, environment)`` slot, but it does hold the chain's
 * open-child slot, and an amendment can fail for a reason no retry fixes --
 * the wrong scopes, which cannot be edited. Refusing to reject those would
 * make the registration permanently unamendable, which is a worse outcome
 * than a recorded divergence. The hazard is warned about in the reject
 * dialog before the decision, and recorded on the activity entry after it.
 */
export const rejectAppRegistration = <ThrowOnError extends boolean = false>(
  options: Options<RejectAppRegistrationData, ThrowOnError>,
): RequestResult<RejectAppRegistrationResponses, RejectAppRegistrationErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RejectAppRegistrationResponses,
    RejectAppRegistrationErrors,
    ThrowOnError
  >({
    url: "/app-registration-requests/{request_id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reconcile App Registrations
 *
 * Where the desk's records and the Entra directory disagree. Admin-only.
 *
 * **Report only, and deliberately not a "fix" button.** Both directions of
 * drift need a human:
 *
 * - a row naming an application the directory no longer holds may be one
 * somebody deleted in the portal on purpose;
 * - a tagged application with no row behind it is the orphan the resume
 * markers cannot catch -- a provisioning run that created the application
 * and died before committing its id -- but it may equally be one being
 * provisioned at this instant, or (with no instance tag) another Scaffold
 * UI instance's in the same tenant.
 *
 * Nothing this endpoint calls deletes anything. An automatic reconciler with
 * delete rights is one bad `$filter` away from removing every application
 * this desk has ever created.
 */
export const reconcileAppRegistrations = <ThrowOnError extends boolean = false>(
  options?: Options<ReconcileAppRegistrationsData, ThrowOnError>,
): RequestResult<ReconcileAppRegistrationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ReconcileAppRegistrationsResponses, unknown, ThrowOnError>({
    url: "/admin/app-registration-reconciliation",
    ...options,
  });
